import React, { useState, useEffect, useRef, ReactNode } from 'react';
import styled from 'styled-components';

type TrProps = { onClick?: (event: unknown) => void };

const Tr = styled.tr<TrProps>`
  ${props => (props.onClick ? 'cursor: pointer;' : '')}
  transition: 0.5s background-color ease;

  &:not(:last-child) td {
    border-bottom: 1px solid var(--separator);
  }

  &:hover td {
    background: var(--primary7);
  }

  /* & td:first-child {
    border-left: 1px solid transparent;
  }
  &:hover td:first-child {
    border-left-color: var(--white);
  } */
`;

type IRow = {
  watchValueForAnimation: string;
  children: ReactNode;
  onClick?: (event: unknown) => void;
  isSelected: boolean;
  isUnderlined: boolean;
  backgroundColor?: string;
  fontSize?: string;
};

/**
 * Row which can highlight itself on each attribute change
 */
export default function ChangeableAnimatedRow({
  watchValueForAnimation,
  children,
  onClick,
  isSelected,
  isUnderlined,
  backgroundColor,
  fontSize,
}: IRow) {
  const [animation, setAnimation] = useState(false);

  const prevValueRef = useRef<string>();
  useEffect(() => {
    let timeout: number | undefined;
    if (
      prevValueRef.current &&
      watchValueForAnimation !== prevValueRef.current
    ) {
      setAnimation(true);
      timeout = window.setTimeout(() => {
        setAnimation(false);
      }, 500);
    }
    prevValueRef.current = watchValueForAnimation;
    return () => {
      if (timeout) {
        clearTimeout(timeout);
      }
    };
  }, [watchValueForAnimation]);
  return (
    <Tr
      onClick={onClick}
      style={{
        ...(isSelected ? { background: 'var(--primary8)' } : {}),
        ...(animation && !isSelected
          ? { backgroundColor: 'rgba(255,255,255, 0.04)' }
          : {}),
        ...(isUnderlined
          ? {
              borderBottom: '1px solid var(--gray1)',
            }
          : {}),
        ...(backgroundColor ? { backgroundColor: backgroundColor } : {}),
        ...(fontSize ? { fontSize } : {}),
      }}
    >
      {children}
    </Tr>
  );
}
